export const MAX_HANDICAP_INDEX = 54.0;

export const formatHandicapIndex = (
  value: number | null | undefined,
  fallback = 'N/A'
): string => (
  typeof value === 'number' && Number.isFinite(value) ? value.toFixed(1) : fallback
);

export const parseHandicapIndex = (value: string): number | null => {
  const trimmed = value.trim();
  if (!/^-?\d+(?:\.\d)?$/.test(trimmed)) return null;

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed) || parsed > MAX_HANDICAP_INDEX) return null;
  return parsed;
};

export const HANDICAP_INDEX_ERROR = 'Enter a Handicap Index with up to one decimal place, no higher than 54.0.';
